/**
 * Lowercase hex SHA-256 of a file, sent with an upload reservation so the
 * server's scan can prove the stored bytes are the ones the user picked
 * (Storage itself does not check uploaded bytes against anything).
 *
 * Returns undefined where Web Crypto is unavailable (an insecure context, or a
 * webview without `crypto.subtle`). The hash is optional on the server; size
 * and content type are still enforced without it.
 */
export async function fileSha256(file: Blob): Promise<string | undefined> {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) {
    return undefined;
  }
  const digest = await subtle.digest("SHA-256", await file.arrayBuffer());
  return Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");
}
